/**
 * Updates Livewell stock messaging when the selected variant changes.
 * Expects .product-messaging to contain:
 * - .variant_inventory_json with livewell_stock_check per variant
 * - .livewell_messages_json with "true"/"false" copy
 * - [data-livewell-messaging] blocks inside stock message wrappers
 */
(function () {
  function getMessagingRoot(target) {
    if (!target) return document.querySelector('.product-messaging');

    var fromTarget = target.closest('.product-messaging');
    if (fromTarget) return fromTarget;

    var productRoot = target.closest('.js-product');
    if (productRoot) {
      var fromProduct = productRoot.querySelector('.product-messaging');
      if (fromProduct) return fromProduct;
    }

    return document.querySelector('.product-messaging');
  }

  function updateLivewellMessaging(variantId, root) {
    var messaging = getMessagingRoot(root);
    if (!messaging || !variantId) return;

    var inventoryEl = messaging.querySelector('.variant_inventory_json');
    var messagesEl = messaging.querySelector('.livewell_messages_json');
    if (!inventoryEl || !messagesEl) return;

    var variants;
    var messages;
    try {
      variants = JSON.parse(inventoryEl.textContent);
      messages = JSON.parse(messagesEl.textContent);
    } catch (e) {
      return;
    }

    var variant = variants.find(function (entry) {
      return String(entry.id) === String(variantId);
    });
    var check = String((variant && variant.livewell_stock_check) || '').toLowerCase();
    var content = messages[check];
    var show = check === 'true' || check === 'false';

    messaging.querySelectorAll('[data-livewell-messaging]').forEach(function (el) {
      if (!show || !content) {
        el.hidden = true;
        return;
      }

      var heading = el.querySelector('[data-livewell-heading]');
      var descript = el.querySelector('[data-livewell-descript]');

      if (heading) {
        heading.textContent = content.heading || '';
      }

      if (descript) {
        if (content.descript) {
          descript.innerHTML = content.descript;
          descript.hidden = false;
        } else {
          descript.innerHTML = '';
          descript.hidden = true;
        }
      }

      el.hidden = false;
    });
  }

  document.addEventListener('on:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) {
      var messaging = getMessagingRoot(event.target);
      if (!messaging) return;
      messaging.querySelectorAll('[data-livewell-messaging]').forEach(function (el) {
        el.hidden = true;
      });
      return;
    }

    updateLivewellMessaging(variant.id, event.target);
  });
})();
